<div class="pay-confirmation text-center" *ngIf="!showManageHealthConfirmation">
    <div class="msg">
        <span class="check-wrap">
            <img src="assets/images/tick.png" alt="checked">
        </span>
        <h3>
            <span>Thank You!</span>
            We've created your account.
            <br>
        </h3>

        <h2 class="colorTheme">
            One last step!
        </h2>
        <p class="colorTheme">
            Download the app now to get access to unlimited free workouts, yoga, meditation, nutrition and more.
            <br />
            Login using the email and password you just created.
        </p>
        <div class="subs-apps">
            <a href="https://apps.apple.com/app/id1558197173" target="_blank">
                <img src="assets/images/icon/apple-app.png" alt="mylifewell">
            </a>
            <a href="https://play.google.com/store/apps/details?id=digifit.android.virtuagym.pro.mylifewell&hl=en&gl=US"
                target="_blank">
                <img src="assets/images/icon/google-app.png" alt="mylifewell">
            </a>
        </div>
        <button *ngIf="" class="btn continue-shooping" [routerLink]="['/']">
            Explore More
        </button>

        <h2 class="hollywood-message colorTheme" *ngIf="showHollyMessage">
            If you want to continue on the web portal please  
            <a href="javascript:void(0)" (click)="redirectToHollywood()" >click here !</a>
        </h2>
    </div>
</div>

<div class="pay-confirmation managehealth-confirmation text-center" *ngIf="showManageHealthConfirmation">
    <div class="msg">
        <span class="managehealth-logo-wrap">
            <img src="assets/images/managehealthlogo.png" alt="ManageHealth logo">
        </span>
        <span class="check-wrap">
            <img src="assets/images/tick.png" alt="checked">
        </span>

        <h3>
            <span>Thank You!</span>
            For signup with ManageHealth
        </h3>

        <h2 class="">
            Your ManageHealth access is ready
        </h2>

        <p class="">
            Download the MyLifeWell to continue with the ManageHealth corporate experience using the email and password you just created.
        </p>

         <div class="subs-apps">
            <a href="https://apps.apple.com/app/id1558197173" target="_blank">
                <img src="assets/images/icon/apple-app.png" alt="mylifewell">
            </a>
            <a href="https://play.google.com/store/apps/details?id=digifit.android.virtuagym.pro.mylifewell&hl=en&gl=US"
                target="_blank">
                <img src="assets/images/icon/google-app.png" alt="mylifewell">
            </a>
        </div>
    </div>
</div>
